<h1 class="h2 mb-4">Securitate</h1>
<!-- Basic info-->
<section class="card border-0 py-1 p-md-2 p-xl-3 p-xxl-4 mb-4">
  <div class="card-body">
    <div class="d-flex align-items-center pb-4 mt-sm-n1 mb-0 mb-lg-1 mb-xl-3"><i
        class="ai-lock-closed text-primary lead pe-1 me-2"></i>
      <h2 class="h4 mb-0">Modificare parola</h2>
    </div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate autocomplete="off">
      <div class="row align-items-center g-3 g-sm-4 pb-3">
        <div class="col-sm-6">
          <label class="form-label" for="oldPassword">Parola curenta</label>
          <div class="password-toggle">
            <input formControlName="oldPassword" #oldPassword
              [ngClass]="{'is-invalid': vs.hasErrors(form, 'oldPassword')}" class="form-control" type="password"
              id="oldPassword">
            <label class="password-toggle-btn" aria-label="Show/hide password">
              <input (click)="oldPassword.type = oldPassword.type == 'password' ? 'text' : 'password'"
                class="password-toggle-check" type="checkbox" tabindex="-1"><span class="password-toggle-indicator"></span>
            </label>
          </div>
          <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'oldPassword')">{{vs.getError(form, 'oldPassword')}}
          </div>
        </div>
        <div class="col-sm-6"><a [routerLink]="['/auth/am-uitat-parola']" tabindex="-1"
            class="d-inline-block fs-sm fw-semibold text-decoration-none mt-sm-4">Ai uitat parola?</a></div>
        <div class="col-sm-6">
          <label class="form-label" for="password">Parola noua</label>
          <div class="password-toggle">
            <input formControlName="password" #password [ngClass]="{'is-invalid': vs.hasErrors(form, 'password')}"
              class="form-control" type="password" id="password">
            <label class="password-toggle-btn" aria-label="Show/hide password">
              <input (click)="password.type = password.type == 'password' ? 'text' : 'password'"
                class="password-toggle-check" type="checkbox" tabindex="-1"><span class="password-toggle-indicator"></span>
            </label>
          </div>
          <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'password')">{{vs.getError(form, 'password')}}
          </div>
        </div>
        <div class="col-sm-6">
          <label class="form-label" for="confirmPassword">Confirmare parola</label>
          <div class="password-toggle">
            <input formControlName="confirmPassword" #confirmPassword
              [ngClass]="{'is-invalid': vs.hasErrors(form, 'confirmPassword')}" class="form-control" type="password"
              id="confirmPassword">
            <label class="password-toggle-btn" aria-label="Show/hide password">
              <input (click)="confirmPassword.type = confirmPassword.type == 'password' ? 'text' : 'password'"
                class="password-toggle-check" type="checkbox" tabindex="-1"><span class="password-toggle-indicator"></span>
            </label>
          </div>
          <div *ngIf="vs.hasErrors(form, 'confirmPassword')" class="invalid-feedback">{{vs.getError(form,
            'confirmPassword')}}
          </div>
        </div>
      </div>
      <div class="alert alert-info d-flex my-3 my-sm-4"><i class="ai-circle-info fs-xl me-2"></i>
        <p class="mb-0">Parola trebuie sa contina minimum 8 caractere (cu cat mai multe, cu atat mai bine) si trebuie sa
          contina cel putin o litera mare, o litera mica si o cifra.</p>
      </div>
      <div class="d-flex justify-content-end pt-3">
        <button [routerLink]="['/user/dashboard']" class="btn btn-secondary" type="button">Anuleaza</button>
        <button class="btn btn-primary ms-3" type="submi">Salveaza</button>
      </div>
    </form>
  </div>
</section>

<!-- Delete account-->
<section class="card border-0 py-1 p-md-2 p-xl-3 p-xxl-4">
  <div class="card-body">
    <div class="d-flex align-items-center pb-4 mt-sm-n1 mb-0 mb-lg-1 mb-xl-3"><i
        class="ai-trash text-primary lead pe-1 me-2"></i>
      <h2 class="h4 mb-0">Dezactivare cont</h2>
    </div>
    <form [formGroup]="formDeleteAccount" (ngSubmit)="onDeleteAccountSubmit()" novalidate autocomplete="off">
      <div class="alert alert-warning d-flex mb-4"><i class="ai-triangle-alert fs-xl me-2"></i>
        <p class="mb-0">Toate datele asociate contului vor fi sterse si nu pot fi recuperate. Contul tau nu poate fi sters daca contine
          tranzactii, dar poate fi dezactivat. </p>
      </div>
      <div class="d-flex flex-column flex-sm-row justify-content-end pt-4 mt-sm-2 mt-md-3">
        <button class="btn btn-danger" type="submit"><i class="ai-trash ms-n1 me-2"></i>Sterge cont</button>
      </div>
    </form>
  </div>
</section>
